/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Success_Verification_SentInputs */

const en_login_success_verification_sent = /** @type {(inputs: Login_Success_Verification_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verification email sent! Please check your inbox.`)
};

const fr_login_success_verification_sent = /** @type {(inputs: Login_Success_Verification_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email de vérification envoyé ! Veuillez vérifier votre boîte de réception.`)
};

const de_login_success_verification_sent = /** @type {(inputs: Login_Success_Verification_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Bestätigungs-E-Mail wurde versendet! Bitte überprüfen Sie Ihren Posteingang.`)
};

const it_login_success_verification_sent = /** @type {(inputs: Login_Success_Verification_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email di verifica inviata! Controlla la tua casella di posta.`)
};

const ru_login_success_verification_sent = /** @type {(inputs: Login_Success_Verification_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Письмо с подтверждением отправлено! Пожалуйста, проверьте свою почту.`)
};

const es_login_success_verification_sent = /** @type {(inputs: Login_Success_Verification_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Correo de verificación enviado! Revisa tu bandeja de entrada.`)
};

const zh_cn2_login_success_verification_sent = /** @type {(inputs: Login_Success_Verification_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`验证邮件已发送！请查收您的邮箱。`)
};

const ja_login_success_verification_sent = /** @type {(inputs: Login_Success_Verification_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`確認メールを送信しました。受信トレイをご確認ください。`)
};

const hi_login_success_verification_sent = /** @type {(inputs: Login_Success_Verification_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सत्यापन ईमेल भेज दिया गया है! कृपया अपना इनबॉक्स देखें।`)
};

const pt_pt2_login_success_verification_sent = /** @type {(inputs: Login_Success_Verification_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail de verificação enviado! Por favor, verifique sua caixa de entrada.`)
};

/**
* | output |
* | --- |
* | "Verification email sent! Please check your inbox." |
*
* @param {Login_Success_Verification_SentInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_success_verification_sent = /** @type {((inputs?: Login_Success_Verification_SentInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Success_Verification_SentInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_success_verification_sent(inputs)
	if (locale === "de") return de_login_success_verification_sent(inputs)
	if (locale === "it") return it_login_success_verification_sent(inputs)
	if (locale === "ru") return ru_login_success_verification_sent(inputs)
	if (locale === "es") return es_login_success_verification_sent(inputs)
	if (locale === "zh-CN") return zh_cn2_login_success_verification_sent(inputs)
	if (locale === "ja") return ja_login_success_verification_sent(inputs)
	if (locale === "hi") return hi_login_success_verification_sent(inputs)
	if (locale === "pt-PT") return pt_pt2_login_success_verification_sent(inputs)
	return en_login_success_verification_sent(inputs)
});